/*
 *  Default reducers for any entity.
 */
import applyReducer from '../applyReducer';
import customLookupReducerFactory from '../factories/customLookupReducerFactory';
import dependentLookupReducerFactory from '../factories/dependentLookupReducerFactory';

// @TODO https://www.pivotaltracker.com/story/show/167581355
// I believe some of these specific entity definitions could be combined. In the case
// where an entity is being restricted, like dependent filters, a custom lookup should be used
// and the base entity shared.

const defaultEntities = ['assetAssociationsArea',
// assetAssociationsAreas.jsx
'assetAssociationsDocument',
// assetAssociations.jsx
'assetAssociationsEmployee',
// assetAssociations.jsx
'assetAssociationsFacility',
// assetAssociationsFacilities.jsx
'assetAssociationsGroup',
// assetAssociationsGroups.jsx
'assetAssociationsOrganization',
// assetAssociationsOrganizations.jsx
'assetCoatingAdhesion',
// assetDetailsConditionItem.jsx
'assetCoatingDetail',
// assetDetailsItemDetailDescription
'assetCoatingDetailDescription',
// assetDetailsItemDetailDescription
'assetCoatingFinish',
// assetDetailsConditionItem.jsx
'assetCoatingSecondaryCondition',
// assetCoatings.jsx
'assetCoatingSubstrate',
// assetDetails.jsx
'assetCoatingSystem',
// assetCoatings.jsx
'assetColor',
// assetProfile.jsx
'assetMaintenanceDescription',
// asset.jsx
'assetMaintenanceFrequencyUnit',
// asset.jsx
'assetMaintenanceType',
// asset.jsx
'assetStatus',
// assetGeneral.jsx
'assetType',
// assetTypeFilter.jsx, assetGeneral.jsx
'assetTypeOther',
// assetGeneral.jsx
'associatedAssetType',
// associatedAssetTypeFilter.jsx
'astm',
// jobContractRequirements.jsx
'coatingScore',
// organization.jsx
'coatType',
// contractSpecDryFilm.jsx
'componentCode',
// jobComponentCodes.jsx
'compCode',
// jobComponentCodes.jsx
'contractSpecFilterContractSpec',
// contractSpec.jsx
'country',
// jobs.jsx, jobGeneral.jsx
'currentState',
// reportFilterPanel.jsx
'currentStateFilterReport',
// reportFilterPanel.jsx
'customRequirement',
// jobContractRequirements.jsx
'displaySettings',
// issueGeneral.jsx
'documentTag',
// documentsBulkActions.jsx
'documentModalJob',
// addDocumentButton.jsx
'employee',
// jobGeneral.jsx
'employeeModalAssign',
// assignmentModal.jsx
'facilityEnvironment',
// facility.jsx
'facilityPrimaryCondition',
// facility.jsx
'flangeValve',
// jobFlangeValve.jsx
'foreman',
// jobGeneral.jsx
'formForm',
// jobs.jsx
'generalManager',
// jobGeneral.jsx
'groupAccess',
// employeeGeneral.jsx
'issueAssignmentModalAssign',
// issueBulkActionCreators.jsx
'issueItem',
// issueTieredSelectModal.jsx
'issueItemGroup',
// issueTieredSelectModal.jsx
'issueItemOther',
// issueTieredSelectModal.jsx
'issueMaintenance',
// issueTieredSelectModal.jsx
'issueModalAssign',
// issues/assignmentModal.jsx
'issueNDT',
// issueTieredSelectModal.jsx
'issueNDTGroup',
// issueTieredSelectModal.jsx
'issueNDTOther',
// issueTieredSelectModal.jsx
'issuePhoto',
// issuePhotos.jsx
'issuePopoverReportDocument',
// issueDetailView.jsx
'issueSeverity',
// issueGeneral.jsx
'issueSeverityFilterIssue',
// issuesFilters.jsx
'issueSeverityFilterReport',
// reportFilters.jsx
'issueStatus',
// issueGeneral.jsx
'issueStatusFilterIssue',
// issuesFilters.jsx
'issueType',
// AnnotationEditor.jsx
'ISO8501',
// jobContractRequirements.jsx
'jobPiece',
// job.jsx
'jobPhaseCodeWithStatus',
// contractSpecGeneral.jsx
'milProfileMeans',
// jobContractRequirements.jsx
'nace',
// jobContractRequirements.jsx
'organizationFilterJob',
// jobs.jsx
'orgFilterReport',
// reportFilterPanel.jsx
'orgSelectJob',
// jobGeneral.jsx
'payGroup',
// employeeGeneral.jsx
'pickerType',
// pickers.jsx
'pieceOtherComponent',
// piecesPickerField.jsx
'pieceComponentReport',
// piecesPickerField.jsx
'phaseCode',
// jobPhaseCodes.jsx
'reportTag',
// reportTags.jsx
'reportType',
// fillFromPreviousButton.jsx
'reportTypeFillFrom',
// fillFromPreviousButton.jsx
'reportTypeIssueBulkExport',
// issueBulkActions.jsx
'jobIssueBulkExport',
// issueBulkActions.jsx
'reportTypeSelectJob',
// jobGeneral.jsx
'reportTypeFilterAdd',
// reports.jsx
'reportTypeFilterReport',
// reportFilterPanel.jsx
'reportAssignment',
// reportFilterPanel.jsx
'reportAssignmentModalAssign',
// reportBulkActionCreators.jsx
'saltTestType',
// contractSpecSaltTest.jsx
'saltType',
// contractSpecSaltTest.jsx
'saltUnit',
// contractSpecSaltTest.jsx
'sspc',
// jobContractRequirements.jsx
'reportTypeIssueType', 'status',
// reportFilters.jsx?, reportFilterPanel.jsx
'statusFilterReport',
// reportFilterPanel.jsx
'state',
// jobs.jsx, jobGeneral.jsx
'summary',
// summaries.jsx
'unitOfArea',
// organizationGeneral.jsx
'user',
// timer.jsx?
'userCertificationType',
// certificationForm.jsx?
'issueIssueItem'];

// defaultEntities are in the form "entity: baseEntity". State updates to baseEntity will trigger
// a reload of the entity
const dependentEntities = {
  creatorFilterIssue: 'employee',
  // issuesFilters.jsx
  creatorFilterReport: 'employee',
  // reportFilters.jsx
  documentTagFilterDocument: 'documentTag',
  // documents.jsx
  employee: 'employee',
  // jobGeneral.jsx
  foreman: 'employee',
  // jobGeneral.jsx
  generalManager: 'employee',
  // jobGeneral.jsx
  jobAndPhaseCode: 'job',
  // jobAndPhaseCodeFilter.jsx
  jobPhaseCode: 'job',
  // phaseCodePickerField.jsx
  jobComponentCodeFilterIssue: 'job',
  // issuesFilters.jsx
  jobComponentCodeSelectIssue: 'job',
  // issueGeneral.jsx
  jobPieceFilterReport: 'job',
  // pieceFilter.jsx
  jobSelectSummary: 'job',
  // summary.jsx
  issueComponentCode: 'componentCode',
  // componentCodePicker.jsx
  organizationFilterJob: 'organization',
  // jobs.jsx
  orgFilterReport: 'organization',
  // reportFilterPanel.jsx
  orgSelectJob: 'organization',
  // jobGeneral.jsx
  pieceOtherFilterReport: 'job',
  // pieceFilter.jsx
  projectManager: 'employee' // jobGeneral.jsx
};

// looper over other entities and add default reducers.
const defaultLookupReducers = {};

// turn off paging for all lookup entities by default. If paging is needed an entry can be created
// in customLookupReducers.js
const indexQueryFragment = {
  paging: null
};

// create reducers for basic lookups
defaultEntities.forEach(entity => {
  const customLookupReducers = customLookupReducerFactory(entity, indexQueryFragment);
  defaultLookupReducers[entity] = applyReducer(customLookupReducers.reducers, customLookupReducers.initState);
});

// create reducers for basic lookups that also need to watch for changes
Object.keys(dependentEntities).forEach(entity => {
  const baseEntity = dependentEntities[entity];
  const dependentLookupReducers = dependentLookupReducerFactory(entity, baseEntity, indexQueryFragment);
  defaultLookupReducers[entity] = applyReducer(dependentLookupReducers.reducers, dependentLookupReducers.initState);
});
export default defaultLookupReducers;